export default "__VITE_ASSET__DNMtRHTO__"